/*
 * @Author: K
 * @Date: 2022-04-08 16:23:14
 * @LastEditors: owen
 * @LastEditTime: 2022-04-19 18:54:41
 * @FilePath: \app-pcweb\src\store\modules\HeadPortrait.js
 */
const Checkout = {
  state: {
    recharge: null,
  },
  mutations: {
    setRecharge(state, data) {
        state.recharge = data;
    },
  },
  getters: {
    getRecharge(state) {
        return state.recharge;
    },
  },
};

export default Checkout;
